const defaultRender = (value) => (value ? value : '--');

const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        render: defaultRender,
    },
    {
        title: 'IP Address',
        dataIndex: 'ip_address',
        render: defaultRender,
    },
    {
        title: 'Message',
        dataIndex: 'message',
        render: defaultRender,
    },
    {
        title: 'Date',
        dataIndex: 'date',
        render: defaultRender,
    },
];

export default columns;